<form
  [formGroup]="form"
  class="add-role-dialog">
  <h2 class="headline">{{ "ROLE_PAGE.MODAL.ADD_ROLE" | translate }}</h2>
  <div class="scroll-block">
    <div class="add-role-dialog__input-block">
      <div
        [class.error]="form.get('roleName')?.invalid && form.get('roleName')?.touched"
        class="input-block-icon">
        <p class="input-block-icon__name">{{ "ROLE_PAGE.MODAL.ROLE_NAME" | translate }}</p>
        <label>
          <img
            src="assets/img/input-user.svg"
            alt="User icon"
            class="input-block-icon__icon" />
          <input
            formControlName="roleName"
            class="input-block-icon__input"
            type="text" />
        </label>
        <ng-container *ngIf="form.get('roleName')?.invalid && form.get('roleName')?.touched">
          <span
            *ngIf="roleNameFormatError"
            class="input-block__error">
            {{ "ROLE_PAGE.MODAL.ERROR_NAME_ROLE" | translate }}
          </span>
          <span
            *ngIf="roleNameRequiredError"
            class="input-block__error">
            {{ "ROLE_PAGE.MODAL.ERROR_NAME_ROLE_REQUIRED" | translate }}
          </span>
        </ng-container>
      </div>
    </div>
    <div class="add-role-dialog__permission">
      <div class="add-role-dialog__permission-block">
        <app-checkbox-block
          [title]="'ROLE_PAGE.MODAL.USERS'"
          [checkList]="userPermissionList"
          (checkboxChange)="checkboxChange($event)"
          (checkboxChangeAll)="checkboxAllChange($event)">
        </app-checkbox-block>
      </div>
      <div class="add-role-dialog__permission-block">
        <app-checkbox-block
          [title]="'ROLE_PAGE.MODAL.PAYMENT_VIEW'"
          [checkList]="paymentViewPermissionList"
          (checkboxChange)="checkboxChange($event)"
          (checkboxChangeAll)="checkboxAllChange($event)">
        </app-checkbox-block>
      </div>
      <div class="add-role-dialog__permission-block">
        <app-checkbox-block
          [title]="'ROLE_PAGE.MODAL.VIRTUAL_POS'"
          [checkList]="virtualPosPermissionList"
          (checkboxChange)="checkboxChange($event)"
          (checkboxChangeAll)="checkboxAllChange($event)">
        </app-checkbox-block>
      </div>
      <div class="add-role-dialog__permission-block">
        <app-checkbox-block
          [title]="'ROLE_PAGE.MODAL.PAYMENT_LINKS'"
          [checkList]="paymentLinksPermissionList"
          (checkboxChange)="checkboxChange($event)"
          (checkboxChangeAll)="checkboxAllChange($event)">
        </app-checkbox-block>
      </div>
      <div class="add-role-dialog__permission-block">
        <app-checkbox-block
          [title]="'ROLE_PAGE.MODAL.SAVED_CARD'"
          [checkList]="savedCardPermissionList"
          (checkboxChange)="checkboxChange($event)"
          (checkboxChangeAll)="checkboxAllChange($event)">
        </app-checkbox-block>
      </div>
      <div class="add-role-dialog__permission-block">
        <app-checkbox-block
          [title]="'ROLE_PAGE.MODAL.SUPPORT'"
          [checkList]="supportPermissionList"
          (checkboxChange)="checkboxChange($event)"
          (checkboxChangeAll)="checkboxAllChange($event)">
        </app-checkbox-block>
      </div>
      <div class="add-role-dialog__permission-block">
        <app-checkbox-block
          [title]="'ROLE_PAGE.MODAL.RECURRING_PAYMENT'"
          [checkList]="recurringPaymentPermissionList"
          (checkboxChange)="checkboxChange($event)"
          (checkboxChangeAll)="checkboxAllChange($event)">
        </app-checkbox-block>
      </div>

      <div class="add-role-dialog__permission-block">
        <app-checkbox-block
          [title]="'ROLE_PAGE.MODAL.ROLES'"
          [checkList]="rolePermissionList"
          (checkboxChange)="checkboxChange($event)"
          (checkboxChangeAll)="checkboxAllChange($event)">
        </app-checkbox-block>
      </div>

      <div class="add-role-dialog__permission-block">
        <app-checkbox-block
          [title]="'ROLE_PAGE.MODAL.PAYMENT'"
          [checkList]="paymentPermissionList"
          (checkboxChange)="checkboxChange($event)"
          (checkboxChangeAll)="checkboxAllChange($event)">
        </app-checkbox-block>
      </div>
      <div class="add-role-dialog__permission-block">
        <app-checkbox-block
          [title]="'ROLE_PAGE.MODAL.TERMINALS'"
          [checkList]="terminalsPermissionList"
          (checkboxChange)="checkboxChange($event)"
          (checkboxChangeAll)="checkboxAllChange($event)">
        </app-checkbox-block>
      </div>
      <div class="add-role-dialog__permission-block">
        <app-checkbox-block
          [title]="'ROLE_PAGE.MODAL.P2P'"
          [checkList]="p2pPermissionList"
          (checkboxChange)="checkboxChange($event)"
          (checkboxChangeAll)="checkboxAllChange($event)">
        </app-checkbox-block>
      </div>
      <div class="add-role-dialog__permission-block">
        <app-checkbox-block
          [title]="'ROLE_PAGE.MODAL.INFO'"
          [checkList]="infoPermissionList"
          (checkboxChange)="checkboxChange($event)"
          (checkboxChangeAll)="checkboxAllChange($event)">
        </app-checkbox-block>
      </div>
      <div class="add-role-dialog__permission-block">
        <app-checkbox-block
          [title]="'ROLE_PAGE.MODAL.ANALYTICS'"
          [checkList]="analyticsPermissionList"
          (checkboxChange)="checkboxChange($event)"
          (checkboxChangeAll)="checkboxAllChange($event)">
        </app-checkbox-block>
      </div>
    </div>
  </div>
  <div class="btn-block">
    <button
      [disabled]="isSending || this.form.invalid"
      (click)="saveRole()"
      class="btn btn-accent">
      {{ "ROLE_PAGE.MODAL.SAVE" | translate }}
    </button>
    <button
      (click)="closeModal()"
      class="btn btn-light">
      {{ "ROLE_PAGE.MODAL.CANCEL" | translate }}
    </button>
  </div>
</form>
